import { Button } from "react-blueprint-library";
import { Col, Row } from "react-bootstrap";
import "./DRPSummaryListMobile.scss";
import { drpSummaryListHeaders } from "../../../constants";

const DRPSummaryListMobile = ({
  date,
  description,
  index,
  isBond,
  isCivilJud,
  isCustomerComplaintArbitrationCivilLitigation,
  isIndividualCriminalDisclosure,
  isInvestigation,
  isJudgmentLien,
  isOrgBankruptcy,
  isOrgCriminalDisclosure,
  isPersBankruptcy,
  isRegulatory,
  isTermination,
  mainIndex,
  orgName,
  qK,
  questionKey,
  status,
  editAction,
  deleteAction,
}) => {
  const descStyle = {
    marginTop: "5px",
    marginBottom: "5px",
  };

  const getRows = () => {
    if (isIndividualCriminalDisclosure) {
      return (
        <>
          {drpSummaryListHeaders.indCriminal.map((header, key) => {
            const value =
              key === 0
                ? date
                : description.map((desc, i) => <div key={i}>{desc}</div>);
            return (
              <Row key={key} className="ind-crim-row">
                <Col>
                  <strong>{header}</strong>
                </Col>
                <Col>{value}</Col>
              </Row>
            );
          })}
        </>
      );
    }
    if (isOrgCriminalDisclosure) {
      return (
        <>
          {drpSummaryListHeaders.orgCriminal.map((header, key) => {
            const value = key === 0 ? date : key === 1 ? orgName : description;
            return (
              <Row key={key} className="org-crim-row">
                <Col>
                  <strong>{header}</strong>
                </Col>
                <Col>{value}</Col>
              </Row>
            );
          })}
        </>
      );
    }
    if (isRegulatory && !isInvestigation) {
      return (
        <>
          {drpSummaryListHeaders.regulatoryAction.map((header, key) => {
            const value = key === 0 ? date : key === 1 ? description : status;
            return (
              <Row key={key} className="reg-action-row">
                <Col>
                  <strong>{header}</strong>
                </Col>
                <Col>{value}</Col>
              </Row>
            );
          })}
        </>
      );
    }
    if (isInvestigation) {
      return (
        <>
          {drpSummaryListHeaders.investigation.map((header, key) => {
            const value = key === 0 ? date : key === 1 ? description : status;
            return (
              <Row key={key} className="investigation-row">
                <Col>
                  <strong>{header}</strong>
                </Col>
                <Col>{value}</Col>
              </Row>
            );
          })}
        </>
      );
    }
    if (isCivilJud) {
      return (
        <>
          {drpSummaryListHeaders.civilJudicial.map((header, key) => {
            const value = key === 0 ? date : key === 1 ? description : status;
            return (
              <Row key={key} className="civil-judicial-row">
                <Col>
                  <strong>{header}</strong>
                </Col>
                <Col>{value}</Col>
              </Row>
            );
          })}
        </>
      );
    }
    if (isCustomerComplaintArbitrationCivilLitigation) {
      return (
        <>
          {drpSummaryListHeaders.customerComplaint.map((header, key) => {
            const value =
              key === 0 ? date : key === 1 ? description : orgName || "Pending";
            return (
              <Row key={key} className="customer-complaint-row">
                <Col>
                  <strong>{header}</strong>
                </Col>
                <Col>{value}</Col>
              </Row>
            );
          })}
        </>
      );
    }
    if (isTermination) {
      return (
        <>
          {drpSummaryListHeaders.termination.map((header, key) => {
            const value = key === 0 ? date : description;
            return (
              <Row key={key} className="termination-row">
                <Col>
                  <strong>{header}</strong>
                </Col>
                <Col>{value}</Col>
              </Row>
            );
          })}
        </>
      );
    }
    if (isBond) {
      return (
        <>
          {drpSummaryListHeaders.bond.map((header, key) => {
            const value = key === 0 ? date : description;
            return (
              <Row key={key} className="bond-row">
                <Col>
                  <strong>{header}</strong>
                </Col>
                <Col>{value}</Col>
              </Row>
            );
          })}
        </>
      );
    }
    if (isPersBankruptcy) {
      return (
        <>
          {drpSummaryListHeaders.personalBankruptcy.map((header, key) => {
            const value =
              key === 0
                ? date
                : key === 1
                  ? description?.length
                    ? description?.map((desc, i) => (
                        <div title={desc || ""} key={`${desc}_${i * 1}`}>
                          {desc || "N/A"}
                        </div>
                      ))
                    : "N/A"
                  : status || "N/A";
            return (
              <Row key={key} className="personal-bankruptcy-row">
                <Col>
                  <strong>{header}</strong>
                </Col>
                <Col>{value}</Col>
              </Row>
            );
          })}
        </>
      );
    }
    if (isOrgBankruptcy) {
      return (
        <>
          {drpSummaryListHeaders.orgBankruptcy.map((header, key) => {
            const value =
              key === 0
                ? date
                : key === 1
                  ? orgName
                  : key === 2
                    ? description?.length
                      ? description?.map((desc, i) => (
                          <div title={desc || ""} key={`${desc}_${i * 1}`}>
                            {desc || "N/A"}
                          </div>
                        ))
                      : "N/A"
                    : status;
            return (
              <Row key={key} className="org-bankruptcy-row">
                <Col>
                  <strong>{header}</strong>
                </Col>
                <Col>{value}</Col>
              </Row>
            );
          })}
        </>
      );
    }
    if (isJudgmentLien) {
      return (
        <>
          {drpSummaryListHeaders.judgmentLien.map((header, key) => {
            const value = key === 0 ? date : key === 1 ? description : orgName;
            return (
              <Row key={key} className="judgment-lien-row">
                <Col>
                  <strong>{header}</strong>
                </Col>
                <Col>{value}</Col>
              </Row>
            );
          })}
        </>
      );
    }
  };
  return (
    <div className="drp-summary-list-mobile">
      {getRows()}
      <Row className="drp-actions">
        <Col>
          <Button
            variant="tertiary"
            onClick={() => {
              editAction();
            }}
          >
            <div>
              <span className="icon-edit"></span>
              Edit
            </div>
          </Button>
        </Col>
        <Col>
          <Button
            variant="tertiary"
            onClick={() => {
              deleteAction();
            }}
          >
            <div>
              <span className="icon-delete"></span>
              Delete
            </div>
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default DRPSummaryListMobile;
